import { render, staticRenderFns } from "./u-tooltip-outlined-rounded-lg.vue?vue&type=template&id=052d28e9&scoped=true&"
import script from "./u-tooltip-outlined-rounded-lg.vue?vue&type=script&lang=js&"
export * from "./u-tooltip-outlined-rounded-lg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d28e9",
  null
  
)

export default component.exports